import * as api from './api';
import { ProductIndexing } from './models';
import * as MutationTypes from './mutationTypes';

export const productIndexingListRequest = async ({
  commit,
  getters: { productIndexingList }
}, pointOfSaleGuid) => {
  if (productIndexingList.length === 0) {
    const response = await api.productIndexingListRequest(pointOfSaleGuid);
    const list = ProductIndexing.toInstanceList(response.data);
    commit(MutationTypes.PRODUCT_INDEXING_LIST_SUCCESS, list);
  }
};

export const createProductIndexingRequest = async ({ commit }, productIndexingToCreate) => {
  const newProduct = productIndexingToCreate.serialize();
  delete newProduct.guid;
  const res = await api.createProductIndexingRequest(newProduct);
  if (res.status === 201) {
    const indexingToCreate = ProductIndexing.deSerializeInternalModel(res.data);
    commit(MutationTypes.CREATE_PRODUCT_INDEXING_SUCCESS, indexingToCreate);
  } else {
    throw new Error('Failed to create');
  }
};

export const removeProductIndexingRequest = async ({ commit }, { referenceProductGuid, productIndexingGuid }) => {
  const res = await api.removeProductIndexingRequest(productIndexingGuid);
  if (res.status === 204) {
    commit(MutationTypes.REMOVE_PRODUCT_INDEXING_SUCCESS, { referenceProductGuid, productIndexingGuid });
  } else {
    throw new Error('Failed to remove');
  }
};

export const editProductIndexingRequest = async ({ commit }, {
  productIndexingGuid,
  productIndexing
}) => {
  const data = productIndexing.serialize(productIndexingGuid);
  const res = await api.editProductIndexingRequest(productIndexingGuid, data);
  if (res.status === 200) {
    const productToEdit = ProductIndexing.deSerializeInternalModel(data);
    commit(MutationTypes.EDIT_PRODUCT_INDEXING_SUCCESS, productToEdit);
  } else {
    throw new Error('Failed to edit');
  }
};
